import { Tab, Tabs, styled } from '@mui/material'
import { a11yProps } from './TabInfo'
import { useTranslation } from 'react-i18next'
import { IFavorite } from '../../models/favorites'
import { ChangeEvent } from 'react'

// interface StyledTabsProps {
//   value: number
//   onChange: (event: React.ChangeEvent<unknown>, newValue: number) => void
// }

const ContainerTab = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.primary.main}`,
  marginBottom: 16,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 0
  },
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 8,
    '& > span': {
      backgroundColor: theme.palette.primary.main,
      height: 8,
      maxWidth: 100,
      borderRadius: '8px 8px 0px 0px',
      width: '100%'
    }
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiTabs-indicator': {
      height: 4,
      '& > span': {
        height: 4,
        borderRadius: '4px 4px 0px 0px'
      }
    }
  }
}))

interface FavoritesTabsProps {
  currentTab: number
  handleChangeTab: (event: ChangeEvent<unknown>, newValue: number) => void
  tmpFavorites: IFavorite
}

const FavoritesTabs = ({ currentTab, handleChangeTab, tmpFavorites }: FavoritesTabsProps) => {
  const { t } = useTranslation(['global'])

  return (
    <ContainerTab
      value={currentTab}
      onChange={handleChangeTab}
      variant="scrollable"
      scrollButtons={true}
      aria-label="favorites tabs"
      TabIndicatorProps={{ children: <span /> }}
    >
      <Tab label={t('library')} {...a11yProps(0)} sx={{ display: tmpFavorites.resources.length > 0 ? 'block' : 'none' }} />
      <Tab label={t('academy')} {...a11yProps(1)} sx={{ display: tmpFavorites.courses.length > 0 ? 'block' : 'none' }} />
      <Tab label={t('novelties')} {...a11yProps(2)} sx={{ display: tmpFavorites.novelties.length > 0 ? 'block' : 'none' }} />
      <Tab label={t('news')} {...a11yProps(3)} sx={{ display: tmpFavorites.news.length > 0 ? 'block' : 'none' }} />
      <Tab label={t('offers')} {...a11yProps(4)} sx={{ display: tmpFavorites.offers.length > 0 ? 'block' : 'none' }} />
      <Tab label={t('catalogs')} {...a11yProps(5)} sx={{ display: tmpFavorites.catalogs.length > 0 ? 'block' : 'none' }} />
      <Tab label={t('seminars')} {...a11yProps(6)} sx={{ display: tmpFavorites.seminars.length > 0 ? 'block' : 'none' }} />
    </ContainerTab>
  )
}

export default FavoritesTabs
